/** Live practice session URL: `/practice/:sessionId` (excludes `new` and `schedule`). */
export function parsePracticeSessionId(pathname: string): string | null {
  const m = pathname.match(/^\/practice\/([^/]+)$/);
  if (!m) return null;
  const seg = m[1];
  if (seg === 'new' || seg === 'schedule') return null;
  return seg;
}
